import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import FeatureTable from "./FeatureTable";
export default function FeatureListPage() {
    return (_jsx("div", { className: "container-fluid", children: _jsx(FeatureTable, {}) }));
}
